<div class="row location-container">
  <div class="col-12 col-xxl-6 left-section" style="text-align: justify;">
    <div class="location">
      <p class="fw-sbold fs-14">{{ sectionInformation?.locationAddress }}</p>
    </div>
    <div class="details d-none d-xxl-block">
      <p class="fs-14" [innerHTML]="sectionInformation?.locationDescription"></p>
    </div>
  </div>
  <div class="col-12 col-xxl-6 map-section">
    <div class="google_map_container">
      <a (click)="redirectServ.openURL(googleMapRoute)" target="_blank" rel="noopener noreferrer">
        @if(!isNativePlatform) {
          <google-map class="google-map d-flex d-lg-block justify-content-center my-small-2" [options]="mapOptions" [center]="mapCenter" [zoom]="13">
            <map-marker [position]="mapCenter" [title]="name">
            </map-marker>
          </google-map>
        } @else {
          <img [src]="utilsV2Serv.buildGalleryImageUrl(pid?.toString(), locationUrl)" class="map-native">
        }
      </a>
    </div>
  </div>
  <div class="col-12 left-section locate-sm d-xxl-none d-block" style="text-align: justify;">
    <p class="fs-14" [innerHTML]="sectionInformation?.locationDescription"></p>
  </div>
</div>